/** @format */

import React from 'react'
import styled from 'styled-components'
import { _$, Card, Divider, dayjs } from '@king-design/react'
import { Descriptions, DescriptionItem } from 'src/components'
import ReactJson from 'react-json-view'
import { RecordItemProp, RecordResultListProps, getDataKeyIsChn } from '../container'
import { isString } from 'lodash'
import ReactMarkdown from 'react-markdown'
import { useHistory } from 'react-router'
// import rehypeRaw from 'rehype-raw'

interface BaseInfoProps {
  className?: string
  baseInfo: RecordItemProp
}

const BaseInfo: React.FC<BaseInfoProps> = ({ className, baseInfo }) => {
  const history = useHistory()
  return (
    <div className={className}>
      <Card title={_$('基本信息')} type="border" style={{ marginBottom: 16 }}>
        <Descriptions columns={3}>
          <DescriptionItem label={_$('开始时间')}>
            {baseInfo?.StartedAt ? dayjs(baseInfo?.StartedAt).format('YYYY-MM-DD HH:mm:ss') : '-'}
          </DescriptionItem>
          <DescriptionItem label={_$('结束时间')}>
            {baseInfo?.FinishedAt ? dayjs(baseInfo?.FinishedAt).format('YYYY-MM-DD HH:mm:ss') : '-'}
          </DescriptionItem>
          <DescriptionItem label={_$('场景内容')}>
            {baseInfo?.Type === 'published' ? (
              <a
                onClick={() => {
                  history.push(`/monitor/eventops/scene/detail/${baseInfo?.SceneSign}`)
                }}
              >
                {_$('查看详情')}
              </a>
            ) : (
              <span className="disabled-text">{_$('查看详情')}</span>
            )}
          </DescriptionItem>

          <DescriptionItem span={2} label={_$('输入参数')}>
            {baseInfo?.Original ? (
              <ReactJson
                src={baseInfo?.Original}
                name={false}
                displayDataTypes={false}
                collapsed
                displayObjectSize={false}
                quotesOnKeys={false}
                enableClipboard={false}
              />
            ) : (
              '-'
            )}
          </DescriptionItem>
          <DescriptionItem span={2} label={_$('输出参数')}>
            {Array.isArray(baseInfo?.ResultList) && baseInfo.ResultList?.length > 0
              ? baseInfo.ResultList.filter(
                  (item: RecordResultListProps) => item.Evaluation !== -1 && item.Evaluation !== -2
                ).map((item: RecordResultListProps) => (
                  <div key={item.ID}>
                    <span>{item.Result}</span>
                    {item.ResultData && (
                      <ReactJson
                        src={item.ResultData}
                        name={false}
                        displayDataTypes={false}
                        collapsed
                        displayObjectSize={false}
                        quotesOnKeys={false}
                        enableClipboard={false}
                      />
                    )}
                  </div>
                ))
              : '-'}
          </DescriptionItem>
          <DescriptionItem span={1} label={_$('执行结果')} className="content_result">
            {Array.isArray(baseInfo?.ResultList) && baseInfo?.ResultList?.length > 0
              ? baseInfo.ResultList.filter(
                  (item: RecordResultListProps) => item.Evaluation !== -1 && item.Evaluation !== -2
                ).map(item => {
                  return (
                    <div key={item.ID}>
                      <Divider position="left" borderType="dashed">
                        📣 {item.Result}
                      </Divider>
                      {item.ResultData &&
                        Object.entries(getDataKeyIsChn(item.ResultData)).map(
                          (mapItem: string[], key: number) => {
                            return (
                              <div key={key} style={{ marginLeft: '20px' }}>
                                <span>{mapItem[0] + '：'}</span>
                                <ReactMarkdown skipHtml={false}>
                                  {isString(mapItem[1])
                                    ? mapItem[1].replace(/\n/g, '<br/>')
                                    : mapItem[1] + ''}
                                </ReactMarkdown>
                              </div>
                            )
                          }
                        )}
                      {item.Remark && <span className="remark">{item.Remark}</span>}
                    </div>
                  )
                })
              : '-'}
          </DescriptionItem>
        </Descriptions>
      </Card>
    </div>
  )
}

export default styled(BaseInfo)``
